import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { faAlignJustify, faAngleLeft, faArrowRightFromBracket, faArrowUpArrowDown, faChevronLeft, faCircleInfo, faGear, faInfoCircle, faKey, faLocationDot, faSearch, faStars, faBell, faXmark, faArrowsRotate } from "@fortawesome/pro-regular-svg-icons";
import { faBadgeCheck, faChevronRight, faCircle, faPencil, faPlus, faQuestionCircle, faTriangleExclamation, faCloudArrowUp, faHexagonExclamation, faClockRotateLeft } from "@fortawesome/pro-solid-svg-icons";
import { Dialog, Transition } from "@headlessui/react";
import classNames from "classnames";
import { filter, get, has, isEmpty, map } from "lodash";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useStoreState } from "pullstate";
import { Fragment, useContext, useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useProductFruitsApi } from "react-product-fruits";
import useCheckDashboardContainer from "../hooks/useCheckDashboardContainer";
import useCheckWorklistContainer from "../hooks/useCheckWorklistContainer";
import { getAppLogo, getCurrentRegion, getIsOnpremise, getIsPatientDeletionEnabled, getIsRemoteSystem, getUrlAuthToken, getUserName, isIOSWebView, isWebView, isQcRadiologistRoleName } from "../utils";
import constants from "../utils/constants";
import getEnv from "../utils/getEnv";
import { trackEvent } from "../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../utils/mixpanelEvents";
import Store from "../utils/Store";
import useCheckViewerPage from "../hooks/useCheckViewerPage";
import { isUltrasoundCapture1, isUltrasoundCapture2 } from "./DefaultViewer/utils/isUltrasoundCapture1";
import { useAuth } from "@qure/qure-auth";
import useChangeTheme from "./Assistant/utils/actions/useChangeTheme";
import useMenubarActions from "./Assistant/utils/actions/useMenubarActions";
import AwesomeIcon from "./AwesomeIcon";
import Button from "./common/Button";
import Dropdown from "./common/Dropdown";
import DropdownMenu from "./common/DropdownMenu";
import Modal from "./common/Modal";
import Tooltip from "./common/Tooltip";
import UserIcon from "./common/UserIcon";
import { GatewayContext } from "./GatewayIndicator/GatewayContext";
import GatewayDropdown from "./GatewayIndicator/GatewayDropdown";
import { LicenseContext } from "./LicenseManager/LicenseContext";
import { PatientsContext } from "./Patients/PatientsContext";
import getPatients from "./Patients/services/getPatients";
import getNotificationsCenter from "./Notifications/services/getNotificationsCenter";
import getUnreadNotificationsCount from "./Notifications/services/getUnreadNotificationsCount";
import markNotificationsRead from "./Notifications/services/markNotificationsRead";
import { playNotificationSound } from "../utils/playNotificationSound";
import SettingsMenu from "./Settings/SettingsMenu";
import useSettings from "./Settings/useSettings";
import TermsAndConditionsModal from "./TermsAndConditionsModal";
import useWorkspacePermittedData from "./WorkspaceManagement/services/useWorkspacePermittedData";
var notificationVariantByType = {
  consent_capture: "warning"
};
var notificationVariantByBucket = {
  immediate_action: "pending"
};
var formatRelativeTime = function formatRelativeTime(date) {
  var dateValue = date.getTime();
  if (Number.isNaN(dateValue)) {
    return "";
  }
  var diffSeconds = Math.round((dateValue - Date.now()) / 1000);
  var absSeconds = Math.abs(diffSeconds);
  var formatter = new Intl.RelativeTimeFormat("en", {
    numeric: "auto"
  });
  if (absSeconds < 60) {
    return formatter.format(diffSeconds, "second");
  }
  var diffMinutes = Math.round(diffSeconds / 60);
  if (Math.abs(diffMinutes) < 60) {
    return formatter.format(diffMinutes, "minute");
  }
  var diffHours = Math.round(diffMinutes / 60);
  if (Math.abs(diffHours) < 24) {
    return formatter.format(diffHours, "hour");
  }
  var diffDays = Math.round(diffHours / 24);
  return formatter.format(diffDays, "day");
};
var formatDateLabel = function formatDateLabel(date) {
  var month = String(date.getMonth() + 1).padStart(2, "0");
  var day = String(date.getDate()).padStart(2, "0");
  var year = String(date.getFullYear()).slice(-2);
  return "".concat(month, "/").concat(day, "/").concat(year);
};
var getNotificationSectionLabel = function getNotificationSectionLabel(dateKey) {
  var now = new Date();
  var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
  var yesterdayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 1).getTime();
  if (dateKey === todayStart) {
    return "Today";
  }
  if (dateKey === yesterdayStart) {
    return "Yesterday";
  }
  return formatDateLabel(new Date(dateKey));
};
var mapNotificationItem = function mapNotificationItem(notification) {
  var createdAt = new Date(notification.created_at);
  var safeCreatedAt = Number.isNaN(createdAt.getTime()) ? new Date() : createdAt;
  var variant = notificationVariantByType[notification.notification_type] || notificationVariantByBucket[notification.notification_bucket] || "default";
  return {
    id: notification.id,
    title: notification.title || notification.patient_id || "Notification",
    body: notification.message || "",
    time: formatRelativeTime(safeCreatedAt),
    variant: variant,
    notificationType: notification.notification_type,
    patientUid: notification.patient_uid,
    unread: !notification.read,
    isPending: notification.notification_bucket === "immediate_action",
    isMuted: notification.read,
    createdAt: safeCreatedAt
  };
};
var buildNotificationSections = function buildNotificationSections(items) {
  var sectionsMap = new Map();
  items.forEach(function (item) {
    var _sectionsMap$get;
    var dayStart = new Date(item.createdAt.getFullYear(), item.createdAt.getMonth(), item.createdAt.getDate()).getTime();
    if (!sectionsMap.has(dayStart)) {
      sectionsMap.set(dayStart, {
        label: getNotificationSectionLabel(dayStart),
        items: [],
        dateKey: dayStart
      });
    }
    (_sectionsMap$get = sectionsMap.get(dayStart)) === null || _sectionsMap$get === void 0 || _sectionsMap$get.items.push(item);
  });
  return Array.from(sectionsMap.values()).map(function (section) {
    return _objectSpread(_objectSpread({}, section), {}, {
      items: _toConsumableArray(section.items).sort(function (a, b) {
        return b.createdAt.getTime() - a.createdAt.getTime();
      })
    });
  }).sort(function (a, b) {
    return b.dateKey - a.dateKey;
  });
};
var Menubar = function Menubar() {
  var _filter$, _activePatientDetail$2, _activePatientDetail$3, _activePatientDetail$4, _ref6, _activePatientDetail$5;
  useChangeTheme();
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var _useState2 = useState(false),
    showSwiftFilter = _useState2[0],
    setShowSwiftFilter = _useState2[1];
  var _useState3 = useState(false),
    isLicenseActivated = _useState3[0],
    setLicenseActivated = _useState3[1];
  var _useState4 = useState(false),
    isTourEnabled = _useState4[0],
    setEnableTour = _useState4[1];
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        swiftModeEnabled: s.swiftModeEnabled,
        hasMobileSearch: s.hasMobileSearch
      };
    }),
    swiftModeEnabled = _useStoreState.swiftModeEnabled,
    hasMobileSearch = _useStoreState.hasMobileSearch;
  var _useState5 = useState(false),
    showTermsAndConditionsModal = _useState5[0],
    setShowTermsAndConditionsModal = _useState5[1];
  var _useState6 = useState("all"),
    notificationTab = _useState6[0],
    setNotificationTab = _useState6[1];
  var _useState7 = useState([]),
    notifications = _useState7[0],
    setNotifications = _useState7[1];
  var _useState8 = useState(null),
    unreadNotificationCount = _useState8[0],
    setUnreadNotificationCount = _useState8[1];
  var previousUnreadCountRef = useRef(null);
  /** Baseline for RA: RA_tone only when unread increase is purely `ultrasound_reupload`. */
  var previousUltrasoundReuploadUnreadRef = useRef(null);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var router = useRouter();
  var params = get(router, ["query", "params"], []);
  var patient_uid = params && params.length ? Number((params === null || params === void 0 ? void 0 : params.length) > 1 ? params === null || params === void 0 ? void 0 : params[1] : params === null || params === void 0 ? void 0 : params[0]) : "";

  // Refresh Zone should only be shown for ultrasound modalities (US 1 / US 2),
  // not for CT or Xray.
  var uploadType = get(router, ["query", "uploadType"]);
  var isUltrasoundMode = isUltrasoundCapture1(uploadType) || isUltrasoundCapture2(uploadType);
  var hideMenubar = !!patient_uid && get(router, ["route"], "").includes("/patients/");
  var isWorkList = useCheckWorklistContainer();
  var isDashboard = useCheckDashboardContainer();
  var isViewer = useCheckViewerPage();
  var _useContext = useContext(PatientsContext),
    patientsData = _useContext.patientsData,
    setLastId = _useContext.setLastId,
    getFilterParams = _useContext.getFilterParams,
    filters = _useContext.filters,
    count = _useContext.count,
    setFilters = _useContext.setFilters,
    wsData = _useContext.wsData;
  var _patientsData = get(patientsData, ["data", "content"], []);
  var _patientsUID = map(_patientsData, "patient_uid");
  var isNotificationSettings = get(router, ["pathname"], "").includes("notification-settings");
  var isGatewayIndicator = get(router, ["pathname"], "").includes("gateway-indicator");
  var isPatientRegistration = get(router, ["pathname"], "").includes("patient-registration");
  var isFormSettings = get(router, ["pathname"], "").includes("form-settings");
  var _useContext2 = useContext(GatewayContext),
    offlineGatewayCount = _useContext2.offlineGatewayCount,
    totalGateway = _useContext2.totalGateway;
  var _useSettings = useSettings(),
    openSetting = _useSettings.openSetting;
  var _useContext3 = useContext(LicenseContext),
    alertDetails = _useContext3.alertDetails;
  var query = get(router, ["query"], {});
  var onlyViewport = has(query, ["onlyViewport"]);
  var ALLOWED_REGIONS_FOR_PHONE_AUTH = ["india-stroke.qure.ai"].concat(_toConsumableArray(constants.TESTING_REGIONS));
  var isViewerPage = (!isWorkList && !isDashboard || isNotificationSettings || isGatewayIndicator || isPatientRegistration) && !isFormSettings;
  var isOnpremise = getIsOnpremise();
  var isPatientDeletionEnabled = getIsPatientDeletionEnabled();
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var userInfoRef = useRef(userInfo);
  userInfoRef.current = userInfo;
  var user = get(userInfo, ["details"], null);
  var _useStoreState2 = useStoreState(Store, function (store) {
      return {
        patient: store.patient,
        isGetFullAccessOpen: store.isGetFullAccessOpen,
        currentPatient: store.patientDetail,
        isSettingsOpen: store.isSettingsOpen,
        isStartingDownload: store.isStartingDownload,
        isDraggableModalMinimized: store.isDraggableModalMinimized,
        worklistSyncStatus: store.worklistSyncStatus,
        isDarkMode: store.isDarkMode,
        pocusCineLoopSelected: store.pocusCineLoopSelected
      };
    }),
    patient = _useStoreState2.patient,
    currentPatient = _useStoreState2.currentPatient,
    isGetFullAccessOpen = _useStoreState2.isGetFullAccessOpen,
    isSettingsOpen = _useStoreState2.isSettingsOpen,
    isDraggableModalMinimized = _useStoreState2.isDraggableModalMinimized,
    worklistSyncStatus = _useStoreState2.worklistSyncStatus,
    isDarkMode = _useStoreState2.isDarkMode,
    pocusCineLoopSelected = _useStoreState2.pocusCineLoopSelected;
  var metabase_enabled = get(userInfo, ["metabase_enabled"], false);
  var phoneNumber = get(userInfo, ["phone_number"], null);
  var diskUsage = get(userInfo, ["disk_usage"], {});
  var isLoggedIn = get(userInfo, ["authenticated"], false);
  var IS_POCUS = getEnv("NEXT_PUBLIC_IS_POCUS") === "true";
  var _useWorkspacePermitte = useWorkspacePermittedData(IS_POCUS && isLoggedIn, constants.WORKSPACE_USER_ROLES.WORKSPACE_PATIENT_UPLOAD),
    _useWorkspacePermitte2 = _useWorkspacePermitte.data,
    workspacePermittedForSound = _useWorkspacePermitte2 === void 0 ? [] : _useWorkspacePermitte2;
  var workspaceRolesForSound = useMemo(function () {
    return Array.isArray(workspacePermittedForSound) ? workspacePermittedForSound.map(function (w) {
      return get(w, "role");
    }).filter(function (r) {
      return typeof r === "string" && !!r.trim();
    }) : [];
  }, [workspacePermittedForSound]);
  var workspaceRolesForSoundRef = useRef(workspaceRolesForSound);
  workspaceRolesForSoundRef.current = workspaceRolesForSound;
  var activePatientDetail = (_filter$ = filter(_patientsData, ["patient_uid", patient_uid])[0]) !== null && _filter$ !== void 0 ? _filter$ : {};
  var page_size = get(patientsData, ["data", "page_size"]);
  var indexOfCurrentPatient = _patientsUID.indexOf(patient_uid);
  var hasPatientDetails = !isEmpty(activePatientDetail) || !isEmpty(patient);
  var urlAuthToken = getUrlAuthToken();
  var DiskAlertbuttonRef = useRef(null);
  var LicenseAlertbuttonRef = useRef(null);
  var LicenseActivateRef = useRef(null);
  var logo = getAppLogo();
  var isQcRadiologist = useMemo(function () {
    if (!IS_POCUS) return false;
    // Primary source: /workspaces/permitted/?permission=WORKSPACE_PATIENT_UPLOAD.
    // The QC role reliably appears here per workspace, unlike /profile/ where it
    // may be absent. Treat the user as QC if ANY permitted workspace is QC.
    if (workspaceRolesForSound.some(function (r) {
      return r.toLowerCase() === constants.POCUS_USER_ROLES.POCUS_QC_RADIOLOGIST;
    })) {
      return true;
    }
    // Fallback to /profile/ (userInfo) in case the workspaces call hasn't resolved.
    if (!userInfo) return false;
    var roleName = get(userInfo, ["details", "name"], "");
    if (isQcRadiologistRoleName(roleName)) return true;
    var role = get(userInfo, ["details", "name"], "").toLowerCase();
    if (role === constants.POCUS_USER_ROLES.POCUS_QC_RADIOLOGIST) return true;
    var sources = get(userInfo, ["accessible_sources"], []);
    return sources.some(function (s) {
      var _s$role;
      return (s === null || s === void 0 || (_s$role = s.role) === null || _s$role === void 0 ? void 0 : _s$role.toLowerCase()) === constants.POCUS_USER_ROLES.POCUS_QC_RADIOLOGIST;
    });
  }, [IS_POCUS, userInfo, workspaceRolesForSound]);

  // Site leads are view-only: they cannot enroll patients. Hide enroll only when
  // every permitted workspace is site-lead (i.e. no workspace grants enroll access).
  // Uses roles from /workspaces/permitted/ since profile accessible_sources often
  // has no role field.
  var isViewOnlySiteLead = useMemo(function () {
    if (!IS_POCUS) return false;
    if (!workspaceRolesForSound.length) return false;
    return workspaceRolesForSound.every(function (role) {
      return (role === null || role === void 0 ? void 0 : role.toLowerCase()) === constants.POCUS_USER_ROLES.POCUS_SITE_LEAD;
    });
  }, [IS_POCUS, workspaceRolesForSound]);
  useProductFruitsApi(function (api) {
    if (getEnv("NEXT_PUBLIC_PRODUCTFRUITS_TOUR_ID") && isTourEnabled) {
      api.tours.tryStartTour(getEnv("NEXT_PUBLIC_PRODUCTFRUITS_TOUR_ID"));
      api.tours.listen("tour-finished", onTourFinished);
      api.tours.listen("tour-skipped", onTourFinished);
    }
  }, [isTourEnabled, getEnv("NEXT_PUBLIC_PRODUCTFRUITS_TOUR_ID")]);
  var onTourFinished = function onTourFinished() {
    setEnableTour(false);
  };
  useEffect(function () {
    if (localStorage.getItem(constants.PERSISTED.isSwiftReportModeEnabled)) {
      Store.update(function (s) {
        s.swiftModeEnabled = true;
      });
    } else {
      Store.update(function (s) {
        s.swiftModeEnabled = false;
      });
    }
  }, []);
  useEffect(function () {
    if (!IS_POCUS || !isLoggedIn) {
      return;
    }
    var isCancelled = false;
    var pollNotifications = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var countResult, countData, newCount, previous, reuploadUnread, previousReupload;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return Promise.allSettled([getUnreadNotificationsCount()]);
            case 1:
              countResult = _context.v;
              if (!isCancelled) {
                _context.n = 2;
                break;
              }
              return _context.a(2);
            case 2:
              if (countResult[0].status === "fulfilled") {
                countData = countResult[0].value;
                if (typeof (countData === null || countData === void 0 ? void 0 : countData.unread_count) === "number") {
                  newCount = countData.unread_count;
                  previous = previousUnreadCountRef.current;
                  reuploadUnread = Number(get(countData, ["immediate_action", "ultrasound_reupload"], 0));
                  previousReupload = previousUltrasoundReuploadUnreadRef.current;
                  if (previous !== null && newCount > previous) {
                    playNotificationSound(userInfoRef.current, workspaceRolesForSoundRef.current, {
                      previousUnreadTotal: previous,
                      currentUnreadTotal: newCount,
                      previousUltrasoundReuploadCount: previousReupload !== null && previousReupload !== void 0 ? previousReupload : 0,
                      currentUltrasoundReuploadCount: Number.isFinite(reuploadUnread) ? reuploadUnread : 0
                    });
                  }
                  previousUnreadCountRef.current = newCount;
                  previousUltrasoundReuploadUnreadRef.current = Number.isFinite(reuploadUnread) ? reuploadUnread : 0;
                  setUnreadNotificationCount(newCount);
                }
              }
            case 3:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function pollNotifications() {
        return _ref.apply(this, arguments);
      };
    }();
    pollNotifications();
    var intervalId = setInterval(pollNotifications, 5000);
    return function () {
      isCancelled = true;
      clearInterval(intervalId);
    };
  }, [IS_POCUS, isLoggedIn]);
  var handleLicenseAlert = function handleLicenseAlert() {
    setTimeout(function () {
      setLicenseActivated(false);
    }, 200);
  };
  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      var _LicenseActivateRef$c;
      if (LicenseActivateRef.current && !(LicenseActivateRef !== null && LicenseActivateRef !== void 0 && (_LicenseActivateRef$c = LicenseActivateRef.current) !== null && _LicenseActivateRef$c !== void 0 && _LicenseActivateRef$c.contains(event.target))) {
        handleLicenseAlert();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return function () {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(function () {
    if (indexOfCurrentPatient === _patientsUID.length - 2 && page_size === 10) {
      setLastId(_patientsUID[_patientsUID.length - 1]);
    }
  }, [indexOfCurrentPatient]);
  var handleChangeButton = function handleChangeButton(type) {
    if (indexOfCurrentPatient !== -1) {
      if (type === "next" && indexOfCurrentPatient !== _patientsData.length) {
        router.replace("/viewer/quredicom/".concat(_patientsUID[indexOfCurrentPatient + 1]));
      } else if (indexOfCurrentPatient !== 0) {
        router.replace("/viewer/quredicom/".concat(_patientsUID[indexOfCurrentPatient - 1]));
      }
      trackEvent(MIXPANEL_EVENTS.VIEWER_HEADER_NAVIGATION, {
        type: type
      });
    } else {
      var filterParams = getFilterParams(filters);
      var _params = _objectSpread(_objectSpread({
        page_size: 1
      }, filterParams), {}, {
        pagination_id: get(router, ["query", "params", 1]),
        page: type
      });
      getPatients(_params, {}).then(function (_patientsData) {
        router.replace("/viewer/quredicom/".concat(get(_patientsData, ["data", "first_id"])));
        trackEvent(MIXPANEL_EVENTS.VIEWER_HEADER_NAVIGATION, {
          type: type
        });
      })["catch"](function (e) {
        console.error("err", e);
      });
    }
  };
  var onBack = function onBack() {
    var canUseHistory = typeof window !== "undefined" && window.history.length > 1;
    var workspaceSlug = get(router, ["query", "params", 0]);
    var patientUidFromRoute = get(router, ["query", "params", 1]) || patient_uid;
    var pocusBackTarget = patientUidFromRoute ? "/patients/".concat(patientUidFromRoute) : "/patients";
    var fromWorklistViewer = typeof window !== "undefined" && sessionStorage.getItem("fromWorklistViewer") === "1";
    // In POCUS flow, prefer true back navigation to return to the originating
    // screen (e.g., patient channel). Fallback to worklist if history is not
    // available. iOS webviews keep the previous behaviour.
    if (IS_POCUS && typeof window !== "undefined") {
      // Mark that we are returning from viewer so Patients page can skip
      // its auto-redirect to worklist on next mount.
      sessionStorage.setItem("fromViewer", "1");
    }
    if (IS_POCUS) {
      // QC rad: back from viewer always goes to worklist (not data collection).
      if (fromWorklistViewer || isQcRadiologist) {
        sessionStorage.removeItem("fromWorklistViewer");
        router.replace("/patients");
        return;
      }
      // Always route to patient channel or worklist directly to avoid stepping
      // through zone history entries.
      router.replace(pocusBackTarget);
    } else if (isIOSWebView()) {
      router.back();
    } else if (canUseHistory) {
      router.back();
    } else if (isIOSWebView()) {
      router.back();
    } else if (canUseHistory) {
      router.back();
    } else {
      router.replace("/patients/".concat(patient_uid));
    }
    trackEvent(MIXPANEL_EVENTS.EXIT_VIEWER);
    Store.update(function (s) {
      s.swiftModeEnabled = false;
    });
    localStorage.removeItem(constants.PERSISTED.isSwiftReportModeEnabled);
    if (swiftModeEnabled) {
      setFilters(constants.DEEFAULT_FILTER);
    }
  };
  useMenubarActions(onBack);
  useEffect(function () {
    if (userInfo !== null && userInfo !== void 0 && userInfo.patients_export) {
      Store.update(function (s) {
        var _userInfo$patients_ex, _userInfo$patients_ex2, _userInfo$patients_ex3, _userInfo$patients_ex4;
        s.isExportReady = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex = userInfo.patients_export) === null || _userInfo$patients_ex === void 0 ? void 0 : _userInfo$patients_ex.available;
        s.exportTimestamp = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex2 = userInfo.patients_export) === null || _userInfo$patients_ex2 === void 0 ? void 0 : _userInfo$patients_ex2.timestamp;
        s.downloadProgress = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex3 = userInfo.patients_export) === null || _userInfo$patients_ex3 === void 0 ? void 0 : _userInfo$patients_ex3.progress;
        s.exportGenFailed = userInfo === null || userInfo === void 0 || (_userInfo$patients_ex4 = userInfo.patients_export) === null || _userInfo$patients_ex4 === void 0 ? void 0 : _userInfo$patients_ex4.failed;
      });
    }
  }, [userInfo]);
  var AddPhoneNumber = function AddPhoneNumber() {
    return /*#__PURE__*/React.createElement("div", {
      className: classNames({
        hidden: isOnpremise || !ALLOWED_REGIONS_FOR_PHONE_AUTH.some(function (region) {
          var _window;
          return (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.host.includes(region);
        })
      }),
      onClick: function onClick() {
        Store.update(function (s) {
          s.addPhoneModal = true;
        });
        var event = MIXPANEL_EVENTS.OPEN_ADD_PHONE_NUMBER;
        if (!isEmpty(phoneNumber)) {
          event = MIXPANEL_EVENTS.OPEN_UPDATE_PHONE_NUMBER;
        }
        trackEvent(event);
      }
    }, !isEmpty(phoneNumber) ? /*#__PURE__*/React.createElement("div", {
      className: "!cursor-pointer text-md text-gray-400 break-all"
    }, phoneNumber, " ", /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faPencil,
      size: "lg",
      className: "w-4 ml-2 text-teal-400"
    })) : /*#__PURE__*/React.createElement("div", {
      className: "text-md text-teal-400 !cursor-pointer hover:underline"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faPlus,
      className: "hidden w-4 mr-2 text-teal-400"
    }), "".concat(t("add_phone.link"), " ").concat(t("phone_number"))));
  };
  useEffect(function () {
    var _showDiskAlert = diskUsage && [75, 80, 85].includes(diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent);
    if (_showDiskAlert) {
      if (DiskAlertbuttonRef.current) {
        var _DiskAlertbuttonRef$c;
        DiskAlertbuttonRef === null || DiskAlertbuttonRef === void 0 || (_DiskAlertbuttonRef$c = DiskAlertbuttonRef.current) === null || _DiskAlertbuttonRef$c === void 0 || _DiskAlertbuttonRef$c.click();
      }
    }
    if ((diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent) > 90) {
      Store.update(function (s) {
        s.isDiskSpaceWarning = true;
      });
    }
  }, [diskUsage]);
  var triggerButtonClick = function triggerButtonClick() {
    if (LicenseAlertbuttonRef !== null && LicenseAlertbuttonRef !== void 0 && LicenseAlertbuttonRef.current) {
      LicenseAlertbuttonRef.current.click();
    }
  };
  useEffect(function () {
    if (alertDetails !== null && alertDetails !== void 0 && alertDetails.isPopupVisible) {
      setTimeout(function () {
        triggerButtonClick();
      }, 800);
    }
  }, [alertDetails]);
  useEffect(function () {
    if ((wsData === null || wsData === void 0 ? void 0 : wsData.action) === "license_renewed") {
      triggerButtonClick();
      setLicenseActivated(true);
    }
  }, [wsData]);
  var onDismissLicenseALert = function onDismissLicenseALert() {
    if (!isEmpty(alertDetails)) {
      var app_name = alertDetails.app_name,
        license_type = alertDetails.license_type,
        total_scans_remaining = alertDetails.total_scans_remaining,
        total_scans = alertDetails.total_scans,
        total_days_remaining = alertDetails.total_days_remaining,
        total_days = alertDetails.total_days,
        remainingPercentage = alertDetails.remainingPercentage;
      var _params2 = {
        app_name: app_name,
        license_type: license_type,
        remainingPercentage: remainingPercentage
      };
      if (license_type === "TIME") {
        _params2 = _objectSpread(_objectSpread({}, _params2), {}, {
          total_days_remaining: total_days_remaining,
          total_days: total_days
        });
      } else if (license_type === "CONT") {
        _params2 = _objectSpread(_objectSpread({}, _params2), {}, {
          total_scans_remaining: total_scans_remaining,
          total_scans: total_scans
        });
      }
      localStorage.setItem("licenseAlertDismissed", JSON.stringify(_params2));
    }
  };
  var diskAlertPrompt = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col p-4 bg-gray-100 overflow-hidden rounded-t text-gray-700"
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-gray-900 text-lg"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faTriangleExclamation,
      size: "xl",
      className: "text-yellow-500"
    }), " ", t("disk_management.x_storage_full", {
      usedPercent: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent
    })), /*#__PURE__*/React.createElement("div", {
      className: "py-4"
    }, t("disk_management.alert", {
      usedPercent: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent,
      totalDisk: diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.total
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grow-1 px-4 py-3 text-gray-500",
      onClick: function onClick() {
        trackEvent(MIXPANEL_EVENTS.DISK_SPACE_ALERT_DISMISSED);
      }
    }, t("button.dismiss")), /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        Store.update(function (s) {
          s.isSettingsOpen = true;
          s.selectedSetting = "disk-management";
        });
        setOpen(true);
        trackEvent(MIXPANEL_EVENTS.DISK_SPACE_ALERT_MANAGE_STORAGE_CLICKED);
      },
      className: "grow-1 px-4 py-3 text-teal-500"
    }, t("disk_management.manage_storage"), " ", ">"))),
    onClick: function onClick() {}
  }];
  var licenseAlertPrompt = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: classNames("flex flex-col p-4 bg-gray-100 overflow-hidden rounded-t text-gray-700 cursor-default", {
        hidden: !get(alertDetails, ["isAlert"], false) || isLicenseActivated || !!(alertDetails !== null && alertDetails !== void 0 && alertDetails.isExpired)
      })
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-gray-900 text-lg"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faTriangleExclamation,
      size: "xl",
      className: "text-yellow-500"
    }), " ", (alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.type) === "days" ? "".concat(alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.total_days_remaining, " ").concat(t("license_manager.days")) : "".concat(alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.total_scans_remaining, " ").concat(t("license_manager.scans")), " ", t("left_key")), /*#__PURE__*/React.createElement("div", {
      className: "py-4"
    }, (alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.type) === "days" ? t("license_manager.license_expire_in_alert").replace("[1]", "".concat(alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.total_days_remaining)) : t("license_manager.license_expire_after_alert").replace("[1]", "".concat(alertDetails === null || alertDetails === void 0 ? void 0 : alertDetails.total_scans_remaining))), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      className: "grow-1 px-4 py-3 text-gray-500 cursor-pointer",
      onClick: function onClick() {
        onDismissLicenseALert();
        trackEvent(MIXPANEL_EVENTS.LICENSE_ALERT_DISMISSED);
      }
    }, t("button.dismiss")), /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        Store.update(function (s) {
          s.isSettingsOpen = true;
          s.selectedSetting = "license";
        });
        setOpen(true);
        trackEvent(MIXPANEL_EVENTS.LICENSE_ALERT_VIEW_DETAILS_CLICKED);
      },
      className: "grow-1 px-4 py-3 text-teal-500 cursor-pointer"
    }, t("view_details"), " ", ">"))),
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: classNames("flex flex-col p-4 bg-gray-100 overflow-hidden rounded-t text-gray-700 cursor-default", {
        hidden: get(alertDetails, ["isAlert"], false) && !isLicenseActivated
      }),
      ref: LicenseActivateRef
    }, /*#__PURE__*/React.createElement("p", {
      className: "text-gray-900 text-lg"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faBadgeCheck,
      size: "xl",
      className: "text-green-500"
    }), " ", t("license_manager.license_activated")), /*#__PURE__*/React.createElement("div", {
      className: "py-4"
    }, t("license_manager.your_license_activated")), /*#__PURE__*/React.createElement("div", {
      className: "flex justify-end"
    }, /*#__PURE__*/React.createElement("div", {
      onClick: handleLicenseAlert,
      className: "grow-1 px-4 py-3 text-gray-500 cursor-pointer"
    }, t("button.dismiss")), /*#__PURE__*/React.createElement("div", {
      onClick: function onClick() {
        Store.update(function (s) {
          s.isSettingsOpen = true;
          s.selectedSetting = "license";
        });
        setOpen(true);
        handleLicenseAlert();
      },
      className: "grow-1 px-4 py-3 text-teal-500 !cursor-pointer"
    }, t("view_details"), " ", ">"))),
    onClick: function onClick() {
      return handleLicenseAlert();
    }
  }];
  var profileNavigations = [{
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start p-4 bg-gray-700 overflow-hidden rounded-t text-white"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(UserIcon, {
      name: getUserName(user),
      className: "h-8 w-8 text-lg"
    })), /*#__PURE__*/React.createElement("div", {
      className: "pl-4 flex flex-col items-start justify-center"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-medium text-base break-all"
    }, getUserName(user)), /*#__PURE__*/React.createElement("div", {
      className: "text-md text-gray-400 break-all"
    }, get(user, ["email"], "")), /*#__PURE__*/React.createElement(AddPhoneNumber, null))),
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start gap-3"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faInfoCircle
    }), /*#__PURE__*/React.createElement("p", null, t("settings.terms-of-use"))),
    onClick: function onClick() {
      setShowTermsAndConditionsModal(true);
      trackEvent(MIXPANEL_EVENTS.OPEN_TERMS_OF_USE);
    }
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start gap-3"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faLocationDot
    }), /*#__PURE__*/React.createElement("p", null, t(getCurrentRegion()))),
    className: "!text-gray-800 dark:!text-gray-200 !cursor-default !bg-transparent",
    onClick: function onClick() {}
  }, {
    name: /*#__PURE__*/React.createElement("div", {
      className: "flex p-4 items-center justify-start"
    }, /*#__PURE__*/React.createElement("div", {
      className: "h-6 w-6 flex items-center justify-center"
    }, /*#__PURE__*/React.createElement(AwesomeIcon, {
      name: faArrowRightFromBracket,
      size: "lg"
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-start pl-3"
    }, t("logout_key"))),
    onClick: function onClick() {
      return Store.update(function (s) {
        s.isLogoutOpen = true;
      });
    }
  }];
  var toggleProductButton = function toggleProductButton() {
    setEnableTour(true);
  };

  // Add keyboard shortcut handler
  useEffect(function () {
    var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
    if (!isAIAssistantEnabled) return;
    var handleKeyDown = function handleKeyDown(e) {
      // Check for CMD+/ (Mac) or CTRL+/ (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === "/") {
        e.preventDefault(); // Prevent default browser behavior
        Store.update(function (s) {
          s.isDraggableModalOpen = !s.isDraggableModalOpen;
          s.isDraggableModalMinimized = false;
        });
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return function () {
      return window.removeEventListener("keydown", handleKeyDown);
    };
  }, [userInfo]);
  var notificationSections = useMemo(function () {
    return buildNotificationSections(notifications);
  }, [notifications]);
  var notificationsUnreadCount = useMemo(function () {
    return notificationSections.reduce(function (total, section) {
      return total + section.items.filter(function (item) {
        return item.unread;
      }).length;
    }, 0);
  }, [notificationSections]);
  if (!onlyViewport && urlAuthToken && !isLoggedIn) {
    var onClose = function onClose() {
      Store.update(function (s) {
        s.isGetFullAccessOpen = false;
      });
    };
    var onOpen = function onOpen() {
      Store.update(function (s) {
        s.isGetFullAccessOpen = true;
      });
    };
    return /*#__PURE__*/React.createElement("header", {
      className: classNames("flex items-center bg-gray-900 px-5 py-4 border-b border-gray-800", {
        "pt-8": isWebView()
      })
    }, /*#__PURE__*/React.createElement(Link, {
      href: "/"
    }, /*#__PURE__*/React.createElement(Image, {
      className: "block h-auto w-auto cursor-pointer",
      src: logo,
      alt: "Qure.ai",
      width: "76",
      height: "25"
    })), /*#__PURE__*/React.createElement("button", {
      className: "bg-teal-500 ml-auto py-3 px-5 rounded-lg",
      onClick: onOpen
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-gray-200"
    }, t("full_access"))), /*#__PURE__*/React.createElement(Modal, {
      show: isGetFullAccessOpen,
      onClose: onClose,
      title: "Get Full Access",
      className: "w-full sm:w-9/12 md:w-8/12 lg:w-6/12 xl:w-5/12",
      closeOnClickAway: true
    }, /*#__PURE__*/React.createElement("div", {
      className: "p-5"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-lg text-gray-800 dark:text-gray-200 py-3"
    }, t("add_worklist_signin_access")), /*#__PURE__*/React.createElement("div", {
      className: "text-gray-100 text-base space-x-5"
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: onClose,
      className: "grow-1 px-6 py-4"
    }, t("no_thanks")), /*#__PURE__*/React.createElement(Button, {
      isPrimary: true,
      onClick: function onClick() {
        router.push("/account/login");
      },
      className: "grow-1 px-6 py-4"
    }, t("add_worklist"))))));
  }
  var tabsOptions = [{
    id: t("worklist_key"),
    label: t("worklist_key"),
    value: "/patients"
  }, {
    id: t("dashboard_key"),
    label: t("dashboard_key"),
    value: "/dashboard"
  }];
  var selectedTab = tabsOptions.find(function (opt) {
    return opt.value === window.location.pathname;
  }) || tabsOptions[0];
  var diskUsageThreshold = parseInt(getEnv("NEXT_PUBLIC_DISK_USAGE_THRESHOLD") || "95", 10);
  var disableAddPatient = isOnpremise && (diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent) >= diskUsageThreshold;
  var visibleNotificationSections = notificationSections.map(function (section) {
    return _objectSpread(_objectSpread({}, section), {}, {
      items: notificationTab === "pending" ? section.items.filter(function (item) {
        return item.isPending && item.unread;
      }) : section.items
    });
  }).filter(function (section) {
    return section.items.length > 0;
  });

  /** Icons by notification_type per Figma: consent_capture (Urgent/500 #E8414E), ultrasound_reupload (Attention/500 #FFA000) */
  var getNotificationIconByType = function getNotificationIconByType(notificationType) {
    switch (notificationType) {
      case "consent_capture":
        return {
          icon: faHexagonExclamation,
          className: "text-[#E8414E]"
        };
      case "ultrasound_reupload":
        return {
          icon: faClockRotateLeft,
          className: "text-[#FFA000]"
        };
      default:
        return null;
    }
  };
  var getNotificationIcon = function getNotificationIcon(variant) {
    switch (variant) {
      case "warning":
        return {
          icon: faTriangleExclamation,
          className: "text-[#FFA000]"
        };
      case "success":
        return {
          icon: faBadgeCheck,
          className: "text-[#00A159]"
        };
      case "pending":
        return {
          icon: faCloudArrowUp,
          className: "text-[#FFA000]"
        };
      default:
        return {
          icon: faPencil,
          className: "text-[#E8414E]"
        };
    }
  };
  var unreadNotificationBadgeCount = unreadNotificationCount === null ? notificationsUnreadCount : unreadNotificationCount;
  var fetchNotificationsCenter = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var centerData, notificationsList, _t;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            _context2.n = 1;
            return getNotificationsCenter();
          case 1:
            centerData = _context2.v;
            notificationsList = Array.isArray(centerData === null || centerData === void 0 ? void 0 : centerData.notifications) ? centerData.notifications.map(mapNotificationItem) : [];
            setNotifications(notificationsList);
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t = _context2.v;
            console.error("Failed to fetch notification center", _t);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function fetchNotificationsCenter() {
      return _ref2.apply(this, arguments);
    };
  }();
  var markNotificationAsRead = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(notificationId) {
      var target, _t2;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            target = notifications.find(function (item) {
              return item.id === notificationId;
            });
            if (!(!target || !target.unread)) {
              _context3.n = 1;
              break;
            }
            return _context3.a(2);
          case 1:
            setNotifications(function (prev) {
              return prev.map(function (item) {
                return item.id === notificationId ? _objectSpread(_objectSpread({}, item), {}, {
                  unread: false,
                  isMuted: true
                }) : item;
              });
            });
            setUnreadNotificationCount(function (prev) {
              if (prev === null) {
                return prev;
              }
              return Math.max(prev - 1, 0);
            });
            _context3.p = 2;
            _context3.n = 3;
            return markNotificationsRead({
              notification_id: notificationId
            });
          case 3:
            _context3.n = 5;
            break;
          case 4:
            _context3.p = 4;
            _t2 = _context3.v;
            console.error("Failed to mark notification as read", _t2);
          case 5:
            return _context3.a(2);
        }
      }, _callee3, null, [[2, 4]]);
    }));
    return function markNotificationAsRead(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleMarkAllAsRead = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var hasUnread, _t3;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            if (!(notifications.length === 0)) {
              _context4.n = 1;
              break;
            }
            return _context4.a(2);
          case 1:
            hasUnread = notifications.some(function (item) {
              return item.unread;
            });
            if (hasUnread) {
              _context4.n = 2;
              break;
            }
            return _context4.a(2);
          case 2:
            setNotifications(function (prev) {
              return prev.map(function (item) {
                return item.unread ? _objectSpread(_objectSpread({}, item), {}, {
                  unread: false,
                  isMuted: true
                }) : item;
              });
            });
            setUnreadNotificationCount(0);
            _context4.p = 3;
            _context4.n = 4;
            return markNotificationsRead({
              mark_all: true
            });
          case 4:
            _context4.n = 6;
            break;
          case 5:
            _context4.p = 5;
            _t3 = _context4.v;
            console.error("Failed to mark all notifications as read", _t3);
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[3, 5]]);
    }));
    return function handleMarkAllAsRead() {
      return _ref4.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Transition.Root, {
    show: open,
    as: Fragment
  }, /*#__PURE__*/React.createElement(Dialog, {
    as: "div",
    className: "relative lg:hidden",
    onClose: setOpen
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "transition-opacity ease-linear duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity ease-linear duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-25"
  })), /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 z-50 flex text-gray-200"
  }, /*#__PURE__*/React.createElement(Transition.Child, {
    as: Fragment,
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: "-translate-x-full",
    enterTo: "translate-x-0",
    leave: "transition ease-in-out duration-300 transform",
    leaveFrom: "translate-x-0",
    leaveTo: "-translate-x-full"
  }, /*#__PURE__*/React.createElement(Dialog.Panel, {
    className: "relative flex flex-col w-full overflow-y-auto bg-gray-800 shadow-xl"
  }, /*#__PURE__*/React.createElement(SettingsMenu, {
    onLogout: function onLogout() {
      Store.update(function (s) {
        s.isLogoutOpen = true;
      });
    },
    onClose: function onClose() {
      return setOpen(false);
    }
  })))))), /*#__PURE__*/React.createElement("header", {
    className: classNames("bg-gray-900 shadow-sm lg:static lg:overflow-y-visible h-fit border-b-none sm:border-b border-gray-800", {
      "hidden sm:!block": hideMenubar,
      "pt-7": isWebView(),
      "!bg-gray-800 sm:!bg-gray-900": isWorkList
    })
  }, !hasMobileSearch && /*#__PURE__*/React.createElement("div", {
    className: "mx-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("relative flex sm:justify-between sm:w-full", {
      "w-full": isWorkList || isDashboard
    })
  }, !(isNotificationSettings || isGatewayIndicator || isPatientRegistration || isFormSettings) && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center sm:hidden inset-y-0"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      setOpen(true);
      trackEvent(MIXPANEL_EVENTS.OPEN_SETTINGS);
    },
    className: "-mx-2 rounded-md p-5 inline-flex items-center justify-center text-gray-200"
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, t("open_menu")), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faAlignJustify,
    size: "lg",
    className: "w-6"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex md:left-0 md:inset-y-0 lg:static xl:col-span-2 w-full sm:w-auto justify-center items-center sm:items-stretch"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-shrink-0"
  }, /*#__PURE__*/React.createElement("span", {
    className: "hidden sm:flex justify-center items-center ml-4 cursor-pointer shrink-0"
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/"
  }, /*#__PURE__*/React.createElement(Image, {
    className: "block h-auto w-auto",
    src: logo,
    alt: "Qure.ai",
    width: "76",
    height: "25"
  }))), (isDashboard || isWorkList) && metabase_enabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-gray-100 flex items-center whitespace-nowrap ".concat(router.asPath === "/dashboard" ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10 ", "\n                                 transition duration-500\n                                 hover:bg-teal-500/10 ml-6 px-4")
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/dashboard"
  }, t("dashboard_key"))), /*#__PURE__*/React.createElement("div", {
    className: "text-gray-100 text-nowrap flex items-center ".concat(/patients/g.test(router.asPath) ? "bg-teal-500/25 border-b-4 border-teal-400" : "border-b-4 border-gray-900 hover:border-teal-400/10", "\n                               transition duration-500 hover:bg-teal-500/10 px-4")
  }, /*#__PURE__*/React.createElement(Link, {
    href: "/patients"
  }, t("worklist_key")))), /*#__PURE__*/React.createElement(Dropdown, {
    options: tabsOptions,
    isBottomAligned: true,
    onChange: function onChange(opt) {
      router.push(opt.value, undefined, {
        shallow: true
      });
    },
    selectedOption: selectedTab,
    hasArrow: true,
    className: classNames("flex sm:hidden font-medium w-full", {
      hidden: getIsRemoteSystem()
    }),
    iconClassName: "text-md text-teal-300",
    parentClassName: "z-50"
  })), isWorkList && !metabase_enabled && /*#__PURE__*/React.createElement("p", {
    className: "text-gray-100 flex items-center sm:hidden"
  }, t("worklist_key")), isViewerPage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    onClick: onBack,
    className: classNames("flex justify-center items-center text-gray-200 cursor-pointer p-5", {
      "ml-8 border-l border-gray-800": !isWorkList && !isNotificationSettings && !isGatewayIndicator && !isFormSettings && !isPatientRegistration
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faAngleLeft,
    className: "ml-3 w-5 mr-3"
  }), t("back_key")), IS_POCUS && patient_uid && isUltrasoundMode && /*#__PURE__*/React.createElement("span", {
    onClick: function onClick() {
      // Trigger zone refresh
      Store.update(function (s) {
        s.refreshZoneTrigger = Date.now();
      });
      trackEvent(MIXPANEL_EVENTS.POCUS_ZONE_REFRESHED, {
        patient_uid: patient_uid
      });
    },
    className: "flex justify-center items-center text-teal-400 cursor-pointer p-5 hover:bg-teal-900 hover:text-teal-300 transition-colors",
    title: pocusCineLoopSelected ? "Refresh Cine Loops" : "Refresh Zone"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faArrowsRotate,
    className: "w-5 mr-2"
  }), pocusCineLoopSelected ? t("refresh_cine_loops", "Refresh Cine Loops") : t("refresh_zone", "Refresh Zone"))))), IS_POCUS && isViewerPage && function (_ref5, _activePatientDetail$) {
    var pid = (_ref5 = (_activePatientDetail$ = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$ !== void 0 ? _activePatientDetail$ : currentPatient === null || currentPatient === void 0 ? void 0 : currentPatient.patient_id) !== null && _ref5 !== void 0 ? _ref5 : patient === null || patient === void 0 ? void 0 : patient.patientID;
    return pid ? /*#__PURE__*/React.createElement("div", {
      className: "flex-1 flex justify-center items-center text-gray-200"
    }, /*#__PURE__*/React.createElement("span", {
      title: pid
    }, String(pid).slice(0, 20))) : null;
  }(), /*#__PURE__*/React.createElement("div", {
    className: classNames("hidden items-center text-white md:space-x-8", {
      "!flex": isViewer && !IS_POCUS
    })
  }, /*#__PURE__*/React.createElement(Tooltip, {
    tooltipContainerStyles: "cursor-pointer",
    tooltipText: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("previous_patient"))),
    position: "right",
    verticalPosition: "bottom",
    tooltipStyles: "text-sm rounded-6 p-3 px-4 text-gray-100",
    tooltipBg: "bg-gray-700"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: (indexOfCurrentPatient === 0 || isEmpty(activePatientDetail)) && indexOfCurrentPatient !== -1,
    onClick: function onClick() {
      handleChangeButton("prev");
    },
    className: "disabled:opacity-50 hidden md:items-center disabled:hover:bg-transparent md:hover:bg-gray-700 md:rounded-6 md:flex md:w-7 md:h-7 md:justify-center"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronLeft,
    className: classNames("text-white hidden stroke-2", {
      "!block": isViewerPage && hasPatientDetails
    })
  }))), /*#__PURE__*/React.createElement("div", {
    className: "items-center text-gray-200 flex"
  }, hasPatientDetails && !isWorkList && !isDashboard && !isNotificationSettings && !isGatewayIndicator && !isFormSettings && !isPatientRegistration && /*#__PURE__*/React.createElement("span", {
    className: "break-all"
  }, ((_activePatientDetail$2 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.name) !== null && _activePatientDetail$2 !== void 0 ? _activePatientDetail$2 : patient === null || patient === void 0 ? void 0 : patient.name) && /*#__PURE__*/React.createElement(React.Fragment, null, (_activePatientDetail$3 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.name) !== null && _activePatientDetail$3 !== void 0 ? _activePatientDetail$3 : patient === null || patient === void 0 ? void 0 : patient.name, " | "), /*#__PURE__*/React.createElement("span", {
    title: (_activePatientDetail$4 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$4 !== void 0 ? _activePatientDetail$4 : patient === null || patient === void 0 ? void 0 : patient.patientID
  }, (_ref6 = (_activePatientDetail$5 = activePatientDetail === null || activePatientDetail === void 0 ? void 0 : activePatientDetail.patient_id) !== null && _activePatientDetail$5 !== void 0 ? _activePatientDetail$5 : patient === null || patient === void 0 ? void 0 : patient.patientID) === null || _ref6 === void 0 ? void 0 : _ref6.slice(0, 10)))), /*#__PURE__*/React.createElement(Tooltip, {
    tooltipContainerStyles: "cursor-pointer",
    tooltipText: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", null, t("next_patient"))),
    position: "left",
    verticalPosition: "bottom",
    tooltipStyles: "text-sm rounded-6 p-3 px-4 text-gray-100",
    tooltipBg: "bg-gray-700"
  }, /*#__PURE__*/React.createElement("button", {
    disabled: (indexOfCurrentPatient === _patientsUID.length - 1 || isEmpty(activePatientDetail)) && indexOfCurrentPatient !== -1,
    className: "disabled:opacity-50 hidden md:items-center md:hover:bg-gray-700 md:rounded-6 md:flex md:w-7 md:h-7 md:justify-center",
    onClick: function onClick() {
      handleChangeButton("next");
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faChevronRight,
    className: classNames("text-white hidden stroke-2", {
      "!block": isViewerPage && hasPatientDetails
    })
  })))), swiftModeEnabled && isViewerPage && /*#__PURE__*/React.createElement("div", {
    className: "border-teal-700 group z-50 relative h-fit my-auto flex items-center border rounded-lg bg-gray-800"
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-teal-800 py-3 pr-5 pl-2 border-teal-700 border-r rounded-l-lg flex items-center space-x-4"
  }, /*#__PURE__*/React.createElement("svg", {
    onClick: function onClick() {
      setShowSwiftFilter(!showSwiftFilter);
    },
    className: "text-teal-500 dark:text-gray-400 w-6 h-6 cursor-pointer",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1406 4.5C15.0273 4.5 15.75 5.22109 15.75 6.10937C15.75 6.51562 15.5977 6.91016 15.2852 7.20703L11.6523 11.1172V18.2266C11.6523 18.9297 11.1172 19.5 10.4141 19.5C10.1289 19.5 9.91797 19.4258 9.71094 19.2891L6.73047 17.3438C6.32422 17.0547 6.0625 16.5625 6.0625 16.0391V11.1172L2.43047 7.20703C2.15375 6.91016 2 6.51562 2 6.10937C2 5.22109 2.72109 4.5 3.61055 4.5H14.1406ZM7.90234 10.75V15.8711L9.77734 17.1094V10.75C9.77734 10.5117 9.90234 10.2852 10.0625 10.1133L13.5312 6.375H4.2168L7.6875 10.1133C7.84766 10.2852 7.90234 10.5117 7.90234 10.75ZM21.0625 17.3125C21.582 17.3125 22 17.7305 22 18.25C22 18.7695 21.582 19.1875 21.0625 19.1875H15.4375C14.918 19.1875 14.5 18.7695 14.5 18.25C14.5 17.7305 14.918 17.3125 15.4375 17.3125H21.0625ZM14.5 12C14.5 11.4805 14.918 11.0625 15.4375 11.0625H21.0625C21.582 11.0625 22 11.4805 22 12C22 12.5195 21.582 12.9375 21.0625 12.9375H15.4375C14.918 12.9375 14.5 12.5195 14.5 12ZM21.0625 4.8125C21.582 4.8125 22 5.23242 22 5.75C22 6.26953 21.582 6.6875 21.0625 6.6875H17.9375C17.418 6.6875 17 6.26953 17 5.75C17 5.23242 17.418 4.8125 17.9375 4.8125H21.0625Z",
    className: "fill-gray-500 dark:fill-gray-400"
  })), /*#__PURE__*/React.createElement("p", {
    className: "font-semibold text-teal-300 "
  }, indexOfCurrentPatient + 1, " of ", count)), /*#__PURE__*/React.createElement("p", {
    className: "text-white font-medium px-5 py-3"
  }, t("swift_report_mode")), /*#__PURE__*/React.createElement("button", {
    title: t("exit_swift_reporting_mode"),
    onClick: function onClick() {
      onBack();
    },
    className: "bg-red-700 invisible group-hover:visible border border-gray-600 rounded-r-lg px-3 py-3"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    className: "w-6 h-6 text-gray-100 stroke-2"
  })), showSwiftFilter && /*#__PURE__*/React.createElement("div", {
    className: "absolute translate-y-[75%] z-50 bg-gray-800 border text-gray-200 gap-4 rounded-xl border-gray-700 flex flex-wrap p-5"
  }, /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, t("negative")), /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, t("screened_by_qure")), /*#__PURE__*/React.createElement("p", {
    className: "bg-gray-700 px-4 py-2 rounded-full"
  }, "CXR"))), /*#__PURE__*/React.createElement("div", {
    className: "hidden sm:flex sm:items-center sm:justify-end xl:col-span-4"
  }, !IS_POCUS && get(userInfo, ["settings", "ui_settings", "ai_assistant"], false) && /*#__PURE__*/React.createElement("button", {
    className: classNames("inline-flex items-center justify-center text-base font-medium rounded-6 " + "text-gray-100 !px-4 !py-2 mr-6 border border-brand-peach hover:opacity-80 cursor-pointer user-select-none"),
    "data-testid": "assistant-button",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_OPEN);
      if (isDraggableModalMinimized) {
        Store.update(function (s) {
          s.isDraggableModalMinimized = false;
        });
      } else {
        Store.update(function (s) {
          s.isDraggableModalOpen = !s.isDraggableModalOpen;
          s.isDraggableModalMinimized = false;
        });
      }
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    label: "aiAssitant",
    name: faStars,
    size: "lg",
    className: "mr-3 text-brand-peach "
  }), /*#__PURE__*/React.createElement("span", {
    className: "hidden sm:inline"
  }, "AI Assistant")), isWorkList && !disableAddPatient && !isViewOnlySiteLead && /*#__PURE__*/React.createElement("button", {
    className: classNames("inline-flex items-center justify-center text-base font-medium rounded-6 text-gray-100 !px-5 !py-3 mr-3 bg-teal-800 hover:bg-teal-900"),
    "data-testid": "add-patient-button",
    onClick: function onClick() {
      return Store.update(function (s) {
        s.uploadModal = {
          isOpen: true,
          hasCurrentPatient: false
        };
      });
    }
  }, IS_POCUS ? t("enroll") : t("add_key"), " "), IS_POCUS && !isViewOnlySiteLead && /*#__PURE__*/React.createElement(DropdownMenu, {
    options: [],
    hasCustomControl: true,
    onButtonClick: fetchNotificationsCenter,
    buttonClassName: "!border-none !bg-transparent hover:!bg-transparent",
    menuItemClassName: "!w-[440px] !p-0 !mt-2 !rounded-[8px] !bg-[#202a35] !border !border-[#474f58] !shadow-[0px_2px_6px_0px_rgba(0,0,0,0.08),0px_8px_26px_0px_rgba(0,0,0,0.12)]",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("div", {
        className: "relative flex h-16 w-14 items-center justify-center text-gray-200 border-b-2 border-transparent hover:text-gray-100 hover:bg-teal-900",
        "aria-label": t("notifications")
      }, /*#__PURE__*/React.createElement("span", {
        className: "relative inline-flex h-6 w-6 items-center justify-center"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faBell,
        size: "lg",
        className: "h-6 w-6"
      }), unreadNotificationBadgeCount > 0 && /*#__PURE__*/React.createElement("span", {
        className: "absolute -top-2 -right-2 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[#E8414E] px-0 text-[12px] font-medium leading-[15px] text-[#D9DBDD]"
      }, unreadNotificationBadgeCount)));
    },
    childrenContent: function childrenContent(_ref7) {
      var close = _ref7.close;
      return /*#__PURE__*/React.createElement("div", {
        className: "relative w-full overflow-hidden"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-between px-4 pb-2 pt-3"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-[16px] font-medium text-[#D9DBDD]"
      }, "Notifications")), /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-between border-b border-[#474f58] px-4 py-2"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex items-center gap-6"
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return setNotificationTab("all");
        },
        className: classNames("relative text-[12px] font-medium leading-4 text-[#D9DBDD] pb-1", {
          "after:absolute after:-bottom-2 after:left-0 after:h-[2px] after:w-full after:bg-[#00D0CD]": notificationTab === "all"
        })
      }, "All"), /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return setNotificationTab("pending");
        },
        className: classNames("relative text-[12px] font-medium leading-4 text-[#D9DBDD] pb-1", {
          "after:absolute after:-bottom-2 after:left-0 after:h-[2px] after:w-full after:bg-[#00D0CD]": notificationTab === "pending"
        })
      }, "Pending")), notifications.length > 0 && /*#__PURE__*/React.createElement("button", {
        type: "button",
        onClick: handleMarkAllAsRead,
        className: "text-[12px] font-normal text-[#9EA3A8] hover:text-[#D9DBDD]"
      }, "Mark all as read")), /*#__PURE__*/React.createElement("div", {
        className: "max-h-[640px] overflow-y-auto"
      }, visibleNotificationSections.length === 0 && /*#__PURE__*/React.createElement("div", {
        className: "px-4 py-6"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-[14px] font-normal leading-5 text-[#D9DBDD]"
      }, "You're all caught up."), /*#__PURE__*/React.createElement("p", {
        className: "text-[14px] font-normal leading-5 text-[#D9DBDD]"
      }, "No pending updates or actions required.")), visibleNotificationSections.map(function (section) {
        return /*#__PURE__*/React.createElement("div", {
          key: section.label
        }, /*#__PURE__*/React.createElement("div", {
          className: "bg-[#29333e] border-b border-[#474f58] px-4 py-1 text-right text-[12px] font-normal text-[#BBBFC2]"
        }, section.label), section.items.map(function (item) {
          var _getNotificationIconB;
          var icon = (_getNotificationIconB = getNotificationIconByType(item.notificationType)) !== null && _getNotificationIconB !== void 0 ? _getNotificationIconB : getNotificationIcon(item.variant);
          return /*#__PURE__*/React.createElement("div", {
            key: item.id,
            onClick: function onClick() {
              var parsedId = typeof item.id === "number" ? item.id : Number(item.id);
              if (!Number.isNaN(parsedId)) {
                markNotificationAsRead(parsedId);
              }
              var uid = item.patientUid;
              if (uid != null && !Number.isNaN(Number(uid))) {
                close();
                if (isQcRadiologist) {
                  sessionStorage.setItem("fromWorklistViewer", "1");
                  router.push("/viewer/quredicom/".concat(uid));
                } else {
                  router.push("/patients/".concat(uid));
                }
              }
            },
            className: classNames("flex gap-3 border-b border-[#474f58] p-4", {
              "bg-[rgba(71,79,88,0.4)]": item.isMuted,
              "bg-[#202a35]": !item.isMuted
            })
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex h-8 w-8 items-start justify-center pt-1"
          }, /*#__PURE__*/React.createElement(AwesomeIcon, {
            name: icon.icon,
            size: "lg",
            className: classNames("w-5", icon.className)
          })), /*#__PURE__*/React.createElement("div", {
            className: "flex flex-1 flex-col gap-3"
          }, /*#__PURE__*/React.createElement("div", {
            className: "flex items-center justify-between"
          }, /*#__PURE__*/React.createElement("p", {
            className: "text-[16px] font-medium text-[#F6F7F7]"
          }, item.title), item.unread && /*#__PURE__*/React.createElement("span", {
            className: "h-[6px] w-[6px] rounded-full bg-[#00D0CD]"
          })), /*#__PURE__*/React.createElement("p", {
            className: "whitespace-pre-line text-[16px] font-normal text-[#D9DBDD] opacity-90"
          }, item.body), /*#__PURE__*/React.createElement("div", {
            className: "flex justify-end"
          }, /*#__PURE__*/React.createElement("span", {
            className: "text-[12px] font-normal text-[#9EA3A8]"
          }, item.time))));
        }));
      })), /*#__PURE__*/React.createElement("div", {
        className: "pointer-events-none absolute bottom-0 left-0 right-0 h-[74px] bg-gradient-to-t from-[rgba(41,51,62,0.8)] to-[rgba(41,51,62,0)]"
      }));
    }
  }), !IS_POCUS && totalGateway > 0 && /*#__PURE__*/React.createElement(DropdownMenu, {
    options: [{
      name: /*#__PURE__*/React.createElement("div", {
        className: "flex p-4 items-center justify-start hover:!bg-teal-500 dark:hover:!bg-teal-800 border-t border-gray-300 dark:border-gray-500/40"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faCircleInfo,
        size: "lg",
        className: "w-6"
      }), /*#__PURE__*/React.createElement("div", {
        className: "flex items-center justify-start ml-3"
      }, t("more_information"))),
      onClick: function onClick() {
        return openSetting(constants.SETTINGS.GATEWAY);
      }
    }],
    menuItemClassName: "z-50 w-80",
    childrenContent: /*#__PURE__*/React.createElement(GatewayDropdown, null),
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("div", {
        className: "relative"
      }, offlineGatewayCount > 0 && /*#__PURE__*/React.createElement("div", {
        className: "absolute border-2 text-gray-100 border-gray-900 flex justify-center items-center text-sm rounded-full bg-red-500 right-4 font-medium top-3 w-5 h-5"
      }, offlineGatewayCount), /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faArrowUpArrowDown,
        size: "lg",
        className: "m-5 text-gray-200"
      }));
    }
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    refer: LicenseAlertbuttonRef,
    options: licenseAlertPrompt,
    menuItemClassName: "z-50 w-80",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement(React.Fragment, null, alertDetails !== null && alertDetails !== void 0 && alertDetails.isAlert ? /*#__PURE__*/React.createElement("div", {
        className: "relative",
        onClick: function onClick(e) {
          if (alertDetails.isExpired) {
            e.stopPropagation();
            Store.update(function (s) {
              s.isSettingsOpen = true;
              s.selectedSetting = "license";
            });
          }
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "absolute -right-3 -top-3"
      }, /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faTriangleExclamation,
        size: "sm",
        className: "m-5 text-yellow-500"
      })), /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: faKey,
        size: "lg",
        className: "m-5 text-gray-200"
      })) : /*#__PURE__*/React.createElement("div", {
        className: "h-8"
      }));
    }
  }), /*#__PURE__*/React.createElement("button", {
    className: classNames("flex group text-gray-200 border-b-2 relative z-10 border-transparent hover:text-gray-100 hover:bg-teal-900", {
      "bg-teal-900 !text-gray-100 !border-teal-500": isSettingsOpen
    }),
    "data-testid": "settings-button",
    onClick: function onClick() {
      Store.update(function (s) {
        s.isSettingsOpen = true;
      });
      trackEvent(MIXPANEL_EVENTS.OPEN_SETTINGS);
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    label: "settings",
    name: faGear,
    size: "lg",
    className: "m-5"
  })), isOnpremise && isPatientDeletionEnabled && (diskUsage === null || diskUsage === void 0 ? void 0 : diskUsage.used_percent) > 75 && /*#__PURE__*/React.createElement(DropdownMenu, {
    refer: DiskAlertbuttonRef,
    options: diskAlertPrompt,
    menuItemClassName: "z-50",
    Icon: function Icon() {
      return /*#__PURE__*/React.createElement("svg", {
        width: "56",
        height: "64",
        viewBox: "0 0 56 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M19 23.75C18.5875 23.75 18.25 24.0875 18.25 24.5V32.0938C18.4891 32.0328 18.7422 32 19 32H37C37.2578 32 37.5109 32.0328 37.75 32.0938V24.5C37.75 24.0875 37.4125 23.75 37 23.75H19ZM18.25 35V39.5C18.25 39.9125 18.5875 40.25 19 40.25H37C37.4125 40.25 37.75 39.9125 37.75 39.5V35C37.75 34.5875 37.4125 34.25 37 34.25H19C18.5875 34.25 18.25 34.5875 18.25 35ZM16 35V24.5C16 22.8453 17.3453 21.5 19 21.5H37C38.6547 21.5 40 22.8453 40 24.5V35V39.5C40 41.1547 38.6547 42.5 37 42.5H19C17.3453 42.5 16 41.1547 16 39.5V35ZM29.125 37.25C29.125 36.9516 29.2435 36.6655 29.4545 36.4545C29.6655 36.2435 29.9516 36.125 30.25 36.125C30.5484 36.125 30.8345 36.2435 31.0455 36.4545C31.2565 36.6655 31.375 36.9516 31.375 37.25C31.375 37.5484 31.2565 37.8345 31.0455 38.0455C30.8345 38.2565 30.5484 38.375 30.25 38.375C29.9516 38.375 29.6655 38.2565 29.4545 38.0455C29.2435 37.8345 29.125 37.5484 29.125 37.25ZM34.75 36.125C35.0484 36.125 35.3345 36.2435 35.5455 36.4545C35.7565 36.6655 35.875 36.9516 35.875 37.25C35.875 37.5484 35.7565 37.8345 35.5455 38.0455C35.3345 38.2565 35.0484 38.375 34.75 38.375C34.4516 38.375 34.1655 38.2565 33.9545 38.0455C33.7435 37.8345 33.625 37.5484 33.625 37.25C33.625 36.9516 33.7435 36.6655 33.9545 36.4545C34.1655 36.2435 34.4516 36.125 34.75 36.125Z",
        fill: "#D9DBDD"
      }), /*#__PURE__*/React.createElement("g", {
        clipPath: "url(#clip0_5582_11554)"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M41.9995 11.25C42.5542 11.25 43.0659 11.543 43.3472 12.0234L51.7847 26.3984C52.0698 26.8828 52.0698 27.4805 51.7925 27.9648C51.5152 28.4492 50.9956 28.75 50.437 28.75H33.562C33.0034 28.75 32.4839 28.4492 32.2066 27.9648C31.9292 27.4805 31.9331 26.8789 32.2144 26.3984L40.6519 12.0234C40.9331 11.543 41.4448 11.25 41.9995 11.25ZM41.9995 16.25C41.48 16.25 41.062 16.668 41.062 17.1875V21.5625C41.062 22.082 41.48 22.5 41.9995 22.5C42.5191 22.5 42.937 22.082 42.937 21.5625V17.1875C42.937 16.668 42.5191 16.25 41.9995 16.25ZM43.2495 25C43.2495 24.6685 43.1178 24.3505 42.8834 24.1161C42.649 23.8817 42.3311 23.75 41.9995 23.75C41.668 23.75 41.3501 23.8817 41.1157 24.1161C40.8812 24.3505 40.7495 24.6685 40.7495 25C40.7495 25.3315 40.8812 25.6495 41.1157 25.8839C41.3501 26.1183 41.668 26.25 41.9995 26.25C42.3311 26.25 42.649 26.1183 42.8834 25.8839C43.1178 25.6495 43.2495 25.3315 43.2495 25Z",
        fill: "#FFA000"
      })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
        id: "clip0_5582_11554"
      }, /*#__PURE__*/React.createElement("rect", {
        width: "20",
        height: "20",
        fill: "white",
        transform: "translate(32 10)"
      }))));
    }
  }), /*#__PURE__*/React.createElement("button", {
    onClick: toggleProductButton,
    className: classNames("hover:bg-teal-900 h-full px-5 border-b-2 border-gray-900", {
      hidden: !getEnv("NEXT_PUBLIC_PRODUCTFRUITS_TOUR_ID")
    })
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faQuestionCircle,
    className: "text-gray-300"
  })), isLoggedIn && /*#__PURE__*/React.createElement(DropdownMenu, {
    options: profileNavigations,
    menuItemClassName: "z-50",
    Icon: function Icon(_ref8) {
      var open = _ref8.open;
      return /*#__PURE__*/React.createElement(UserIcon, {
        className: classNames("h-7 w-7 m-4 group-hover:bg-gray-700", {
          "!bg-gray-700": open
        }),
        name: getUserName(user)
      });
    },
    dataTestId: "user-profile-dropdown"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "p-5 sm:hidden flex justify-end items-center"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      Store.update(function (s) {
        s.hasMobileSearch = true;
      });
    },
    className: classNames("relative text-white", {
      hidden: !isWorkList
    })
  }, (filters === null || filters === void 0 ? void 0 : filters.isFilterApplied) && /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircle,
    size: "2xs",
    className: "absolute top-0 right-1 text-teal-400 p-1 bg-gray-800 rounded-full"
  }), /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faSearch,
    className: "w-6"
  }))))), showTermsAndConditionsModal && /*#__PURE__*/React.createElement(TermsAndConditionsModal, {
    onClose: function onClose() {
      setShowTermsAndConditionsModal(false);
    },
    showModal: showTermsAndConditionsModal
    // closeOnClickAway
    ,
    mode: "readonly"
  })));
};
export default Menubar;